import styled from "styled-components";

/* Spacing between count items — 20px gap; margin-top: auto pins to bottom of card */
export const MetaData = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
  margin-top: auto;
  gap: 20px;
  padding-left: 0;
`;

/* Icon 16px, slate/600, 8px gap to text */
export const MetaIcon = styled.span`
  font-size: 16px;
  width: 16px;
  height: 16px;
  color: #475569;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
`;

/* Body/sm/regular: Inter Regular 14/20, slate/600 */
export const MetaContent = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 0;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #475569;
  padding: 0;
  position: relative;
  &:not(:first-child)::before {
    content: "";
    display: none;
  }
`;
